export const selectCallStartOwner = ({ newCallsEnabled, nativeCallAvailable = false, }) => {
    if (!newCallsEnabled)
        return 'element';
    if (nativeCallAvailable)
        return 'livekit-mobile';
    return 'livekit-js';
};
//# sourceMappingURL=callStartSelection.js.map